import apiClient from "./axiosInstanceStock";

export const getStock = async () => {
  return await apiClient.get(`/v1/stocks`);
};

export const getStocksByBoatOwner = async (boid) => {
  return await apiClient.get(`/stockdetailsbyboatowner/${boid}`);
};
